import type { MouseEvent } from 'react';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import ProgressBar from '@/components/Chart/ProgressBar/ProgressBar';
import Tooltip from '@/components/Tooltip/TooltipV2';
import Typo from '@/components/Typography/Typo';
import { radius } from '@/styles/sizes';

type Props = {
  name: StringNumberValue;
  count: number;
  max: number;
  onClick?: (e: MouseEvent) => void;
};

const TopListItem = (props: Props) => {
  return (
    <Style j="space-between" a="center" g={16} onClick={props.onClick}>
      <Tooltip tooltipNode={props.name}>
        <Typo type="label2" style={{ flex: 1 }} ellipsis>
          {props.name}
        </Typo>
      </Tooltip>
      <Flex a="center" g={6}>
        <Typo type="label3">{props.count}</Typo>
        <ProgressBar
          current={props.count}
          total={props.max}
          style={{ width: 72 }}
        />
      </Flex>
    </Style>
  );
};

const Style = styled(Flex)`
  width: 100%;
  padding: 12px;
  border-radius: ${radius.label}px;
  transition: all 0.2s;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.colors.hover};
  }
`;

export default TopListItem;
